import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';

import BarrierGlyph from '@/components/map/BarrierGlyph';
import CarGlyph from '@/components/map/CarGlyph';
import type { PanelMode } from '@/utils/panelMode';

interface WorkspaceSegmentedProps {
  readonly value: PanelMode;
  readonly onChange: (next: PanelMode) => void;
}

/**
 * Top-of-panel segmented switcher between the Routes and Barriers
 * libraries. Visible when no draft is in flight; clicking a segment
 * also clears any active selection — cross-type navigation collapses
 * a stale property view before revealing the other library.
 */
export default function WorkspaceSegmented({
  value,
  onChange,
}: WorkspaceSegmentedProps) {
  const { t } = useTranslation();
  return (
    <Segmented<PanelMode>
      block
      value={value}
      onChange={onChange}
      options={[
        {
          value: 'routes',
          label: t('nav.routes'),
          icon: <CarGlyph />,
        },
        {
          value: 'barriers',
          label: t('nav.barriers'),
          icon: <BarrierGlyph />,
        },
      ]}
    />
  );
}
